'use client';

/**
 * connect0 skill §Q.9 — per-route error boundary. A render error
 * inside /controls isolates here instead of bubbling to the root
 * global-error boundary (which would unmount the marketing chrome).
 */
import { RouteError } from '@/components/route-error';

export default function RouteErrorBoundary(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError {...props} label="Controls" />;
}
